import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sysinfo-view',
  templateUrl: './sysinfo-view.component.html',
  styleUrls: ['./sysinfo-view.component.scss'],
})
export class SysinfoViewComponent {
  @Input() versionData;
  @Input() launchResources;
  @Input() codes;
  @Output() downloadCodes = new EventEmitter<void>();
  @Output() generateCodes = new EventEmitter<void>();
}
